export enum RouteName {
  appCatalog = 'estate-owner-app-catalog',
}
